import axios, { AxiosError } from "axios";
import { Auth } from "../utils/auth";
import { IdNameDto } from "../models";
import config from "../config";
import { AppPermissions, FeatureFlags, TechnicalAccountManager } from "./models/CustomerManagement";
import { useQuery, UseQueryResult } from "react-query";

export const loadTenants = async () => {
  const token = await Auth.getToken([]);
  return await axios.get<IdNameDto[]>(`${config.infoboardBackendUrl}/tenants/all`, {
    headers: {
      Authorization: `Bearer ${token.token}`
    }
  })
};

export const loadInfoboard = async() => {
  const token = await Auth.getToken([]);
  return await axios.get(`${config.infoboardBackendUrl}/messages/infoboard`, {
    headers: {
      Authorization: `Bearer ${token.token}`
    }
  });
}

export const useGetTechnicalAccountManager = (enabled?: boolean) : UseQueryResult<TechnicalAccountManager, unknown> => {
  return useQuery({
    queryKey: ["technicalAccountManager"],
    queryFn: async () => {
      const token = await Auth.getToken([]);
      const response = await axios.get<TechnicalAccountManager>(`${config.infoboardBackendUrl}/tenants/technicalAccount`, {
        headers: {
          Authorization: `Bearer ${token.token}`
        }
      });
      return response.data;
    },
    retry: false,
    enabled: enabled,
    staleTime: 1000
  });
}

export const useGetPermissions = (enabled?: boolean, onError?: (error: AxiosError)=> void) : UseQueryResult<AppPermissions, AxiosError> => {
  return useQuery({
    queryKey: ["permissions"],
    queryFn: async () => {
      const token = await Auth.getToken([]);
      const response = await axios.get<AppPermissions>(`${config.infoboardBackendUrl}/tenants/permissions`, {
        headers: {
          Authorization: `Bearer ${token.token}`
        }
      });
      return response.data;
    },
    onError: onError,
    enabled: enabled,
    retry: false,
    staleTime: 3_600_000
  });
}

export const useGetFeatureFlags = (onError?: (error: AxiosError)=> void) : UseQueryResult<FeatureFlags, AxiosError> => {
  return useQuery({
    queryKey: ["featureFlags"],
    queryFn: async () => {
      const token = await Auth.getToken([]);
      const response = await axios.get<FeatureFlags>(`${config.infoboardBackendUrl}/tenants/feature-flags`, {
        headers: {
          Authorization: `Bearer ${token.token}`
        }
      });
      return response.data;
    },
    onError: onError,
    retry: false,
    staleTime: 3_600_000
  });
}